module.exports = __webpack_public_path__ + "static/img/andartornament.5744209.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gamecompetition/andartornament.png
// module id = UR14
// module chunks = 0